import { MenuItemConnectedAccount } from './styles';

export default MenuItemConnectedAccount;
